var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertLoginMethod = function SvgAlertLoginMethod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5L13.25 3.5V8.25C13.25 11.35 11.05 13.6 8 14.5C4.95 13.6 2.75 11.35 2.75 8.25V3.5L8 1.5Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8L7.25 9.5L10.25 6",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAlertLoginMethod;